"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RequestQueryException extends Error {
    constructor(msg) {
        super(msg);
    }
}
exports.RequestQueryException = RequestQueryException;
